module.exports = __webpack_public_path__ + "img/tw-icon.9dec3e9f.svg";